import React, { ChangeEvent } from 'react';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import Paths from '@root/utils/Path';
import { compose } from 'react-apollo';
import { withRouter, RouterProps } from 'react-router';
import { Orders_orders_data, OrdersVariables } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { ApolloQueryResult } from "apollo-client";
import { Orders } from "@api/graphql/types";

interface State {
    isLoading: boolean;
    order?: Orders_orders_data;
    id: string;
}


class OrderSearchForm extends React.Component<{} & RouterProps & InjectedIntlProps, State> {

    public state = {
        isLoading: false,
        id: '',
    };

    private async getOrders(filters: {id?: string}) {
        const response: ApolloQueryResult<Orders> = await GraphQLClient.query<Orders, OrdersVariables>({
            query: Queries.orders,
            variables: {filters, count: 100, page: 1},
        });
        if (response.data.orders) {
            const orders = response.data.orders.data;
            if (orders.length === 1) {
                const order = orders[0];
                this.setState({isLoading: false, order, id: order.id});
                return;
            }
        }
        this.setState({isLoading: false, order: undefined, id: (filters.id || '')});
    }

    private idChange = (e: ChangeEvent<HTMLInputElement>) => {
        const id = e.currentTarget.value;
        this.setState({order: undefined, id, isLoading: true}, async () => {
            this.getOrders({id});
        });
    }

    public render() {
        // @ts-ignore
        const order = this.state.order;
        const name = order ? order.contact_data.contact_name : '';
        const totalAmount = order ? `${order.total_amount} Ft` : '';
        return (
            <form className="form-horizontal">
                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.id.title'})}</label>

                    <div className="col-sm-8">
                        <input type="text" value={this.state.id} name="id" placeholder={this.props.intl.formatMessage({id: 'module.dashboard.id.title'})} className="form-control" onChange={this.idChange} />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.name.title'})}</label>

                    <div className="col-sm-8">
                        <div className="form-control" style={{backgroundColor: '#eee'}}>{name}</div>
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.totalAmount.title'})}</label>
                    <div className="col-sm-8">
                        <div className="form-control" style={{backgroundColor: '#eee'}}>{totalAmount}</div>
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-12">
                        <button
                            className="btn btn-primary btn-block"
                            disabled={!order}
                            onClick={() => {
                                if (order) {
                                    this.props.history.push(`${Paths.order}/${order!.id}`);
                                }
                            }}
                        >{this.state.isLoading ? this.props.intl.formatMessage({id: 'common.loading'}) : this.props.intl.formatMessage({id: 'common.open'})}</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(OrderSearchForm);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/components/OrderSearchForm.tsx